module.exports = (Promise.resolve(__parcel__require__("./" + "RistrettoPlaying.0b70c1b3.a07f2895.js"))).then(() => parcelRequire('lJgPp'));